let Selects = {
    options: function($item, item_required){
        var options = {
            onInitialize: function (value) {
                this.$dropdown.css('visibility', 'hidden').css('opacity', '0');

                if ($(this).closest('form') && !!item_required){
                    this.$input.prop('required', 'required');
                }
            },
            onChange: function(value){
                var elem = this.$input[0],
                    container = $(elem).closest('[data-select-wrap]');

                // fix бага selectize с выбранным элементом
                container.find('.option').removeClass('selected');
                container.find('[data-value="'+value+'"].option').addClass('selected');

                var $selectWrap = this.$input.closest('.select__wrap'),
                    $formgroup = $selectWrap.closest('.form-group');

                if(this.$input.val() != ''){
                    $selectWrap.removeClass('select__wrap_error');
                    $formgroup.removeClass('form-group_error');
                    $formgroup.find('label.error').remove();
                }
            },
            onDropdownOpen: function (dropdown) {
                var self = this;

                $(dropdown)
                  .css('width', this.$control[0].offsetWidth + 'px')
                  .css('top', this.$control[0].offsetHeight + 'px')
                  .css('visibility', 'visible')
                  .css('opacity', '1');

                $(dropdown).addClass('has-scrollbar');
                $(dropdown).find('.selectize-dropdown-content').addClass('nano-content');

                setTimeout(function(){
                    $(dropdown).nanoScroller({scroll: 'top'});
                    self.$dropdown[0].nanoscroller.reset();
                }, 100);
            },
            onDropdownClose: function (dropdown) {
                $(dropdown).css('visibility', 'hidden').css('opacity', '0');

                setTimeout(function () {
                    $(dropdown).prev().find('input').blur();
                }, 250);
            }
        }

        return options;
    },
    init: function(){
        let selectForm = $('[data-select]');
        if (selectForm.length) {
            selectForm.each(function () {
                let $item = $(this),
                    item_required = $item.attr('required');

                $item.selectize(Selects.options($item, item_required));
            });
        }
    }
}

$(document).ready(function($) {
    Selects.init();
})


// WEBPACK FOOTER //
// ./components/selects.js